import { VAT_RATE } from './constants.js';

export const uid    = () => Math.random().toString(36).slice(2) + Date.now().toString(36);

// Single source of truth for customer catalogue links. The ?admin=1 flag is
// read by CatalogueView's impersonation detector — building it here keeps
// every entry point ("View as customer" in Token Manager and Applications)
// in step with that reader.
export const catalogueUrl = (token, { admin = false } = {}) =>
  `${window.location.origin}/catalogue/${token}${admin ? '?admin=1' : ''}`;
// Catalogue cards render inside a ~230x200 cell, but the stored images are
// ~1400px — about 56 KB each where 15 KB would do. scripts/migrate/06-thumbnails.mjs
// writes a 400px copy under thumbs/, and this derives that URL. Callers must keep
// an onError fallback to the original: a product uploaded after the thumbnail run
// has no thumbnail, and must still show a picture rather than a broken card.
export const thumbUrl = (url) => {
  if (typeof url !== 'string') return url;
  const marker = '/product-images/';
  const i = url.indexOf(marker);
  if (i === -1 || url.includes('/product-images/thumbs/')) return url;
  return url.slice(0, i + marker.length) + 'thumbs/' + url.slice(i + marker.length);
};

export const fmt    = (n) => `${Number(n).toLocaleString('en-EG')} EGP`;
export const fmtVat = (n) => {
  const rounded = Math.ceil(Number(n) * (1 + VAT_RATE) / 5) * 5;
  return `${rounded.toLocaleString('en-EG')} EGP`;
};
